import styled from 'styled-components';
import { useTransfersView } from '#/features/transfers/transfers-context';
import { useTranslation } from '#/features/localization/utils';
import TabLabel, { Badge } from './TabLabel';

export default function TabLabelTransfers() {
  const transfersView = useTransfersView();
  const { t } = useTranslation();

  return (
    <TabLabel>
      <Text>
        {t('Deposit')} / {t('Withdraw')}
      </Text>
      <Badge>{transfersView.activeCount}</Badge>
    </TabLabel>
  );
}

const Text = styled.span`
  min-width: 100px;
`;
